import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IBrandDetailPostDtoModel } from "../../models/brand/dto/brand-detail-post-dto.model";
import { IBrandDetailPutDtoModel } from "../../models/brand/dto/brand-detail-put-dto.model";
import { IBrandDetailResponseDtoModels } from "../../models/brand/dto/brand-detail-response.dto.models";

import { EnvironmentService } from "../environment.service";

@Injectable({
    providedIn: 'root'
})
export class BrandService {
    fullPath: string;
    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/brands`;
    }

    public get(id: string): Observable<IBrandDetailResponseDtoModels> {
        return this.httpClient.get<IBrandDetailResponseDtoModels>(`${this.fullPath}`);
    }

    public save(model: IBrandDetailPostDtoModel): Observable<IBrandDetailPostDtoModel> {
        return this.httpClient.post<IBrandDetailPostDtoModel>(this.fullPath, model);
    }

    public update(model: IBrandDetailPutDtoModel): Observable<IBrandDetailPutDtoModel> {
        return this.httpClient.put<IBrandDetailPutDtoModel>(this.fullPath, model);
    }
}